Questa prova contiene _9 domande_ da risolvere in _50 minuti_.
Le domande sono a **scelta multipla** o a **risposta aperta numerica**, e sono divise in tre parti:

- domande di **pensiero logico**,
- domande di **pensiero algoritmico**, e
- domande di interpretazione di **procedimenti procedurali** come programmi a blocchi.

In tutte le tre parti, le domande sono ordinate per difficoltà crescente.
**Attento che la difficoltà è soggettiva!** Se stai passando tanto tempo cercando di risolvere una domanda, prova a passare ad altre domande e altre categorie!

## Punteggio

Tutte le domande a _scelta multipla_ hanno 5 opzioni, di cui **solo una** è corretta. Il punteggio che puoi ottenere è:

- 5 punti per una risposta _corretta_;
- 1 punto per una risposta _non data_;
- 0 punti per una risposta _sbagliata_.

Le domande a _risposta aperta_ hanno come risposta un numero (senza virgola o segno). Il punteggio che puoi ottenere è:

- 5 punti per una risposta _corretta_;
- 0 punti per una risposta _sbagliata_ o _non data_.

Attenzione che alcune domande potrebbero richiedere più risposte numeriche a richieste diverse, tutte valutate separatamente!
